import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { obraMedicaoAction } from '../../_actions'
import PropTypes from 'prop-types'
import moment from 'moment'
import {
  Grid,
  IconButton,
  Input,
  Paper,
  Tooltip,
  Skeleton,
  TablePagination,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { withStyles } from '@mui/styles'
import { withRouter } from 'react-router-dom'
import { history, MANUAIS_CATEGORIAS } from '../../utils'
import TitleContent from '../TitleContent'
import { useConfirm } from 'material-ui-confirm'
import { AccessControl } from '../../components/Utils/AccessControl'
import AccessDenied from '../Errors/AccessDenied'
import { Page } from 'components'
import { useDebounce } from 'use-debounce';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(6, 6, 6, 6)
  },
  textField: {
    fontSize: 8
  }
})

const ObraMedicao = (props) => {

  const confirm = useConfirm()
  const dispatch = useDispatch()
  const { classes, className } = props
  const { obraMedicao } = props.obraMedicao
  const { totalRegistros } = props.obraMedicao
  const { isLoading } = props.obraMedicao

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [term, setTerm] = useState('');
  const [debounceTerm] = useDebounce(term, 1000);
  const [order] = useState('data');
  const [direction] = useState('desc');
  const [ready, setReady] = React.useState(false);
  const isCronograma = true;

  const { idOrgao } = useSelector(
    (state) => state.usuarioOrgao
  )

  useEffect(() => {

    const fetchData = (page, limit, term) => {

      //Listar apenas as em aberto
      let filterModel = {
        Page: page,
        Limit: limit,
        Term: term,
        Order: order,
        Direction: direction,
        IdOrgao: idOrgao ? idOrgao : 0,
        Situacao: 0
      };

      dispatch(obraMedicaoAction.getObraMedicao(filterModel, true));
    };

    fetchData(page, limit, debounceTerm, order, direction);

  }, [page, limit, debounceTerm, order, direction, idOrgao]);

  useEffect(() => {

  }, [totalRegistros, isLoading]);

  useEffect(() => {
  }, [ready, props.obraMedicao.isLoading])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeLimit = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClick = (id) => {
    confirm({
      title: 'Você deseja excluir este cronograma?',
      description: 'Essa operação é irreversível',
      disabled: props.obraMedicao.isLoading,
      confirmationText: props.obraMedicao.isLoading ? 'Excluindo cronograma...' : 'Sim, excluir!',
      cancellationText: 'Não!'
    }).then(() => {
      dispatch(obraMedicaoAction.deleteObraMedicaoById(id))
    })
  }

  const handleChange = prop => event => {
    setTerm(event.target.value);
  };

  useEffect(() => {

    let filterModel = {
      Page: page,
      Limit: limit,
      Term: term,
      Order: order,
      Direction: direction,
      IdOrgao: idOrgao ? idOrgao : 0,
      Situacao: 0
    };

    dispatch(obraMedicaoAction.getObraMedicao(filterModel, true));

  }, []);

  return (
    <Page className={classes.root} title="Cronogramas">
      <AccessControl
        rule={'obrasMedicoes.list'} //permissão necessária para acessar conteúdo
        yes={() => (
          <div>
            {undefined !== obraMedicao && (
              <TitleContent
                length={obraMedicao.length ?? 0}
                subTitle={'GERÊNCIA DE MEDIÇÕES'}
                title={'Lista de Medições Pendentes'}
                href={'/obraMedicao'}
                telaManual={MANUAIS_CATEGORIAS.LISTAGEM_MEDICAO}
              />
            )}
            <Grid container spacing={3}>
              <Grid item xl={3} lg={3} md={3} xs={12}>
                <Input
                  id="term"
                  label="term"
                  placeholder="Filtro"
                  value={term}
                  fullWidth
                  onChange={handleChange('term')}
                />
              </Grid>
            </Grid>
            <br />
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Data</TableCell>
                    <TableCell align="center">Obra</TableCell>
                    <TableCell align="center">Usuário</TableCell>
                    <TableCell align="center">Órgão</TableCell>
                    <TableCell align="center">Situação</TableCell>
                    <TableCell align="center">Valor</TableCell>
                    <TableCell align="center">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {undefined !== obraMedicao && obraMedicao.length
                    ? obraMedicao.map((n) => {
                      console.log(n)
                      return (
                        <TableRow hover key={n.id}>
                          <TableCell component="th" scope="row">
                            {n.data ? moment(n.data).format("DD/MM/YYYY") : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.obra ? n.obra.titulo : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.usuario ? n.usuario.nome : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.obra ? n.obra.orgao.nome : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.situacao == 1 ? 'APROVADO' : n.situacao == 2 ? 'RECUSADO' : 'PENDENTE DE ANÁLISE'}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {'R$ ' + n.valor.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                          </TableCell>
                          <TableCell align="right">
                            <AccessControl
                              rule={'obrasMedicoes.list'} //permissão necessária para acessar conteúdo
                              yes={() => (
                                <IconButton
                                  aria-label="Visualizar"
                                  component="a"
                                  onClick={() =>
                                    history.push(`/obra/${n.idObra}`, { isCronograma })
                                  }
                                  size="small"
                                >
                                  <Tooltip title={'Visualizar Cronograma'}>
                                    <Tooltip >
                                      <VisibilityIcon />
                                    </Tooltip>
                                  </Tooltip>
                                </IconButton>
                              )}
                            />
                            <AccessControl
                              rule={'obrasMedicoes.delete'} //permissão necessária para acessar conteúdo
                              yes={() => (
                                <IconButton
                                  aria-label="Delete"
                                  onClick={() => handleClick(n.id)}
                                  size="small"
                                >
                                  <Tooltip title="Excluir">
                                    <DeleteIcon />
                                  </Tooltip>
                                </IconButton>
                              )}
                            />
                          </TableCell>
                        </TableRow >
                      )
                    })
                    :
                    (
                      !isLoading ?
                        <TableRow>
                          <TableCell rowSpan={3} colSpan={6} align="center">Nenhum registro encontrado</TableCell>
                        </TableRow>
                        :
                        Array.apply(null, { length: 5 }).map((e, i) => (
                          <TableRow hover>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                          </TableRow>
                        ))
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalRegistros}
              page={page}
              labelRowsPerPage="Linhas por página"
              labelDisplayedRows={({ from, to }) => `${from}-${to} de ${totalRegistros}`}
              onPageChange={handleChangePage}
              rowsPerPage={limit}
              onRowsPerPageChange={handleChangeLimit}
            />
          </div >
        )
        }
        no={() => <AccessDenied />}
      />
    </Page >
  )
}
ObraMedicao.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return state
}
const connectedObraMedicaoPage = withRouter(
  connect(mapStateToProps, null, null)(withStyles(styles)(ObraMedicao))
)
export { connectedObraMedicaoPage as ObraMedicao }
